var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCamera48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2252_9212)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6826 6.94843H27.318C28.6682 6.94843 29.8659 7.81492 30.2884 9.09732L31.2975 12.1607H16.7031L17.7122 9.09732C18.1347 7.81492 19.3324 6.94843 20.6826 6.94843Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88474 9.03333H10.9696C11.5454 9.03333 12.0121 9.50005 12.0121 10.0758V12.1607H7.84229V10.0758C7.84229 9.50005 8.30901 9.03333 8.88474 9.03333Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2007 12.1607H6.79972C5.07253 12.1607 3.67236 13.5609 3.67236 15.2881V37.1796C3.67236 38.9068 5.07253 40.307 6.79972 40.307H41.2007C42.9279 40.307 44.3281 38.9068 44.3281 37.1796V15.2881C44.3281 13.5609 42.9279 12.1607 41.2007 12.1607Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 36.6583C29.7575 36.6583 34.4248 31.9911 34.4248 26.2338C34.4248 20.4765 29.7575 15.8093 24.0002 15.8093C18.2429 15.8093 13.5757 20.4765 13.5757 26.2338C13.5757 31.9911 18.2429 36.6583 24.0002 36.6583Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1159 19.4579C39.9795 19.4579 40.6796 18.7578 40.6796 17.8942C40.6796 17.0306 39.9795 16.3305 39.1159 16.3305C38.2523 16.3305 37.5522 17.0306 37.5522 17.8942C37.5522 18.7578 38.2523 19.4579 39.1159 19.4579Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2252_9212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.00268555)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCamera48);
export default __webpack_public_path__ + "static/media/pictogramBeaconCamera48.1ef210b600c46092208c84c725994bb3.svg";
export { ForwardRef as ReactComponent };